<template>
  <TWModal
  :title="$t('LegacyAllItemsDescriptionModal.title')"
  :show="value"
  :loading="false"
  :auto-focus="false"
  @close="close">
    <template v-slot:content>
      <p>{{ $t('LegacyAllItemsDescriptionModal.description') }}</p>
      <p>{{ $t('LegacyAllItemsDescriptionModal.suggestion') }}</p>
    </template>
    <template v-slot:controls>
      <button
        type="button"
        class="tw-button tw-button-cta"
        data-test="confirm-button"
        data-ec="template-share-modal"
        data-et="save-button"
        @click="close">
        <span>{{ $t('functional.gotIt') }}</span>
      </button>
    </template>
  </TWModal>
</template>

<script>
import TWModal from '@/components/tailwind/Modal.vue';

export default {
  name: 'LegacyAllItemsDescriptionModal',
  components: {
    TWModal,
  },
  data: () => ({
    isOpen: false,
  }),
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
  },
};
</script>

<style>

</style>
